/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: packageCreationTemplates-resource-factory
 *
 * Created by sjacobs on 3/16/18.
 */

angular
    .module('prism-ui.components.data')
    .factory('PackageCreationTemplatesResourceFactory', ($resource: JS5Function, EndPointService: JS5Object) => {
        return $resource(EndPointService.packageCreationTemplatesEndpoint + '/:id',
            {
                id: '@id',
                fetchOffset: '@fetchOffset',
                fetchLimit: '@fetchLimit',
                searchString: '@searchString',
                includeHidden: '@includeHidden'
            },
            {
                getPackageCreationTemplate: {
                    method: 'GET',
                    params: {
                        id: '@id'
                    },
                    url: `${EndPointService.packageCreationTemplatesEndpoint}/:id`,
                    isArray: false
                },
                createPackageCreationTemplate: {
                    method: 'POST',
                    url: `${EndPointService.packageCreationTemplatesEndpoint}`,
                    isArray: false
                },
                updatePackageCreationTemplate: {
                    method: 'PUT',
                    url: `${EndPointService.packageCreationTemplatesEndpoint}`,
                    isArray: false
                },
                deletePackageCreationTemplate: {
                    method: 'DELETE',
                    params: {
                        id: '@id'
                    },
                    url: `${EndPointService.packageCreationTemplatesEndpoint}/:id`,
                    isArray: false
                }
            }
        );
    });

